define('viewModels/privileged/qm/policies/editors/TeamSelectorView',[
    'lib/lodash4',
    'lib/bluebird',
    'lib/knockout',
    'services/teamService',
    'services/loggingService',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'lib/knockout.validation'
], function (_, Promise, ko, teamService, LOG, ViewModel) {
    'use strict';

    /**
     * The TeamSelectorView class.
     * @class
     */
    var TeamSelectorView = ViewModel.extend(function (teamsObservable, options) {
        var self = this;

        self.teams = teamsObservable;
        self.placeholderText = ko.i18n.renderString('teamSelectorView.placeholderText');
        self.isOpen = ko.observable(false);

        var lookupTeams = function (searchTerm) {

            var teamsPromise;
            if (searchTerm.length > 0) {
                var queryObject = {
                    pageSize: 25,
                    query: [{
                        fields:["name"],
                        value: searchTerm.trim(),
                        type:"STARTS_WITH",
                        operator:"AND"
                    }]
                };

                teamsPromise = teamService.searchTeams(queryObject)
                .then(function (response) {
                    return ko.toJS(response);
                });
            } else {
                teamsPromise = teamService.getTeams({pageSize: 25})
                .then(function (response) {
                    return ko.toJS(response.entities);
                });
            }

            return teamsPromise
                .then(function (filteredTeams) {
                    var unwrappedTeams = ko.unwrap(self.teams);

                    _.remove(filteredTeams, function(team){
                        var shouldRemove = !!_.find(unwrappedTeams, {"id": team.id});
                        if (!shouldRemove){
                            if (options && options.ignoredIds){
                                return _.includes(options.ignoredIds(), team.id);
                            }
                        }
                        return shouldRemove;
                    });

                    return filteredTeams;
                })
                .catch(function (error) {
                    LOG.error("Couldn't retrieve teams", { error: error });
                    return [];
                });
        };

        self.getTeams = function (searchTerm) {
            return lookupTeams(searchTerm);
        };

        if (options && options.teamValidation){
            self.teams.extend(options.teamValidation);
        } else {
            if (_.isArray(self.teams())) {
                self.teams.extend({deepComparer: true, minLength: {params: 1, message: "teamSelectorView.noTeamsSelected"}});
            } else {
                self.teams.extend({required: ko.observable(true)});
            }
        }


    }, true /* pass args to extended class */);

    return TeamSelectorView;
});

